<template>
    <Loading class="detail-module-skeleton">
        <div class="d-flex align-items-center mt-2">
            <Avatar class="avatar-icon mr-2 mb-2" />
            <Row class="row-40" />
        </div>

        <div class="d-flex align-items-center">
            <Avatar class="avatar-icon mr-2 mb-2" />
            <Row class="row-40" />
        </div>

        <Row class="mt-4 w-50" />
        <Row class="ml-5 row-40" />
        <Row class="mt-4 w-50" />
        <Row class="ml-5 row-40" />
        <Row class="ml-5 row-40" />

        <Row class="mt-4 row-button" />
    </Loading>
</template>

<script>
import Loading from '~/components/skeletons/base/Loading';
import Row from '~/components/skeletons/base/Row';
import Avatar from '~/components/skeletons/base/Avatar';

export default {
    name: 'DetailModuleSkeleton',
    components: { Row, Avatar, Loading },
};
</script>

<style scoped>
.detail-module-skeleton {
    min-height: 200px;
}

.row-40 {
    width: 40% !important;
}

.row-button {
    height: 38px !important;
    border-radius: 3px !important;
}

.avatar-icon {
    height: 17px !important;
    width: 17px !important;
}
</style>
